import { render, staticRenderFns } from "./IconSquare.vue?vue&type=template&id=519baf4e"
import script from "./IconSquare.vue?vue&type=script&lang=js"
export * from "./IconSquare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports